import { useState } from 'react'
import { Flex, Img } from '@chakra-ui/react'
import LogoIcon from '../../assets/wrk_logo.png'
export interface OrganisationBranding {id:string;name:string;logo?:string|null}
/** Keep tenant artwork uncropped; mismatched or broken artwork uses the product mark. */
export default function OrganisationLogo({branding,organisationId}:{branding?:OrganisationBranding|null;organisationId?:string|null}) {
 const [failed,setFailed]=useState<string|null>(null)
 const tenant=branding && branding.id===organisationId && branding.logo && branding.logo!==failed ? branding : null
 return <Flex height="58px" width="100%" align="center" justify="center" minW={0}>
  <Img key={tenant?.logo||'aboutwork'} src={tenant?.logo||LogoIcon} alt={tenant?.name||'AboutWork'} maxW="100%" width={tenant?'144px':'100px'} height={tenant?'44px':'58px'} flexShrink={0} objectFit="contain" onError={tenant?.logo?()=>setFailed(tenant.logo!):undefined}/>
 </Flex>
}
